import { useModels } from "@/shared/api/models";
import ProviderMark from "@/shared/components/models/ProviderMark";
import { modelOf, providerOf, selectionOf } from "@/shared/lib/models";
import { AgentAppStack } from "./AgentAppStack";
import { useAgentApps } from "./hooks/useAgentApps";

import type { Agent } from "@/shared/types";

/* The agent's setup on the chat composer's strip, in one box that opens its Settings: its main
   model's mark, then its connected apps as the sidebar stacks them (three, then +N). The names
   are in the tooltip and for screen readers. */
export default function ConfigSummary({ agent, onOpen }: { agent: Agent; onOpen: () => void }) {
  const { data: models } = useModels();
  const apps = useAgentApps(agent.id);
  const selection = selectionOf(agent);
  const model = modelOf(selection, models)?.name ?? selection.modelId;
  const label = ["Settings", [model, ...apps.map((app) => app.name)].join(", ")].join(": ");

  return (
    <button
      onClick={onOpen}
      title={label}
      aria-label={label}
      // one padding with or without apps: the box only grows by the logos as they load
      className="press shrink-0 h-[26px] px-[5px] rounded-[8px] flex items-center gap-[7px] bg-[var(--surface)] ring-1 ring-[var(--hairline-strong)] shadow-lift hover:ring-[var(--hairline-focus)]"
    >
      <ProviderMark provider={providerOf(selection, models)} size="xs" />
      {apps.length > 0 && (
        <>
          <span aria-hidden="true" className="w-px h-3.5 bg-[var(--hairline-strong)]" />
          <AgentAppStack agent={agent} on="card" />
        </>
      )}
    </button>
  );
}
